import { render } from "./LineChart.vue?vue&type=template&id=2a5ff12e&scoped=true"
import script from "./LineChart.vue?vue&type=script&lang=ts"
export * from "./LineChart.vue?vue&type=script&lang=ts"

import "./LineChart.vue?vue&type=style&index=0&id=2a5ff12e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a5ff12e"

export default script